"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiManager = void 0;
var axios_1 = __importDefault(require("axios"));
var TypeCheck_1 = require("../utils/TypeCheck");
var ApiManager = /** @class */ (function () {
    function ApiManager(initValue) {
        // 전역 설정
        this.defaultInterceptor = function (cb) {
            axios_1.default.interceptors.response.use(function (response) {
                var locale = TypeCheck_1.TypeCheck.itemsByPath(response, "headers.locale");
                var version = TypeCheck_1.TypeCheck.itemsByPath(response, "headers.version");
                // 서버 버전 전달
                cb.callbackServerVersion(version);
                if (locale) {
                    // 한국의 경우 성인 체크버튼 비노출 (정책 적용) 0 비대상 1 대상
                    var result = locale.toLowerCase() === "kr" ? "0" : "1";
                    // UserDefault.setNormalMode(result);
                    cb.callback(result);
                }
                return response;
            }, function (error) {
                return Promise.reject(error);
            });
        };
        /**
         * 관리자용 interceptor
         * @param errorCallback
         */
        this.managerInterceptor = function (errorCallback) {
            axios_1.default.interceptors.response.use(function (response) {
                return response;
            }, function (error) {
                var _a;
                // logout 처리
                if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
                    errorCallback.onErrorLogout();
                }
                return Promise.reject(error);
            });
        };
        // 임시로 any타입 지정
        // axios.defaults.baseURL = process.env.BASE_URL;
        // axios.defaults.headers.common['x-api-key'] = process.env.API_KEY;
        // axios.defaults.headers.common.deviceId = UserDefault.getUdid();
        axios_1.default.defaults.baseURL = initValue.baseUrl;
        axios_1.default.defaults.headers.common = {
            "x-api-key": initValue.apiKey,
            version: initValue.version,
            deviceId: initValue.uuid,
        };
        axios_1.default.defaults.timeout = 60 * 1000;
        this.instance = axios_1.default;
        // this.defaultInterceptor();
    }
    return ApiManager;
}());
exports.ApiManager = ApiManager;
